module.exports = __webpack_public_path__ + "img/chef.40bc6bb3.png";